module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/pages/portfolio-case-study-3d4cd055a1aa2ff5c14000fb76d7bbf4.jpg";